import { Principal, type Subject } from "gitpod-next-api/gitpod/v1/identity_pb";
import type { PlainMessage } from "@bufbuild/protobuf";

/**
 * Returns the user ID from a Subject if it represents a user, otherwise undefined.
 */
export function getUserId(subject: PlainMessage<Subject> | Subject | undefined | null): string | undefined {
    if (subject?.principal === Principal.USER && subject.id) {
        return subject.id;
    }
    return undefined;
}
